import { useState } from "react";
import { useLogin } from "../context/LoginContext";

import { Text, Button, Dialog, Icon, Checkbox, HelperText } from '@ui-component-library';

import { formattedPhoneNumber } from "../helpers";
import { isValidPhoneNumber } from 'react-phone-number-input';

export default function LoginMain() {
    const LoginContext = useLogin();

    const [cancelPopup, showCancelPopup] = useState(false);

    const isPhoneValid = (val) => {
        if(formattedPhoneNumber(val) && isValidPhoneNumber(formattedPhoneNumber(val))) {
            return true
        } else {
            return false
        }
    }

    return <>
        {LoginContext.isLogged ? <>
            <Text variant='subheaderSmallMedium' className='mb-2'>Koppla Mobilt bankID</Text>

            <Text variant='bodySmallRegular' className='text-pebble-500 mb-8'>För en smidigare och tryggare upplevelse rekommenderar vi att du kopplar ditt konto med Mobilt BankID.</Text>

            <Button tw variant='secondary' onClick={() => {LoginContext.data.next_url ? window.location.href = LoginContext.data.next_url : LoginContext.close(false)}} className='mt-2' fullWidth>Hoppa över</Button>

            <Button tw variant='primary' onClick={() => LoginContext.setView('bankid')} className='mt-3' fullWidth>Koppla Mobilt BankID</Button>
        </> : LoginContext.checkIfRegister() ? <>
            <Text variant='subheaderSmallMedium' className='mb-2'>Skapa ditt konto</Text>

            <Text variant='bodySmallRegular' className='text-pebble-500 mb-8'>Ange din e-postadress och telefonnummer.</Text>

            {LoginContext.getFormFields()}

            <Checkbox className='my-4' checked={LoginContext.data.is_buyer} onClick={(value) => LoginContext.setData(prev => ({...prev, is_buyer: value}))}>
                <Text variant="labelMediumRegular">Jag är virkesköpare.</Text>
            </Checkbox>

            <Button tw variant='secondary' onClick={() => showCancelPopup(true)} className='mt-2' fullWidth>Avbryt</Button>

            <Button tw variant='primary' onClick={() => LoginContext.sendLoginRegister()} className='mt-2' disabled={LoginContext.loading || (!LoginContext.data.email || !isPhoneValid(LoginContext.data.mobile_phone_number))} fullWidth>Skapa Konto {LoginContext.loading && <div class="size-4 border-2 border-charcoal-500 border-t-transparent border-solid rounded-full animate-spin"></div>}</Button>

            <Checkbox className='mt-4' checked={LoginContext.data.marketing_subscribed} onClick={(value) => LoginContext.setData(prev => ({...prev, marketing_subscribed: value}))}>
                <Text variant="labelMediumRegular">Jag vill få marknadsanalys, inbjudningar till seminarier samt erbjudanden (du kan när som helst avsluta prenumerationen).</Text>
            </Checkbox>

            <Checkbox className='mt-4' checked={LoginContext.data.terms_and_conditions_accepted} onClick={(value) => {LoginContext.setData(prev => ({...prev, terms_and_conditions_accepted: value})); LoginContext.setErrors(prev => ({...prev, terms_and_conditions_accepted: undefined}))}}>
                <Text variant="labelMediumRegular">Genom att fortsätta godkänner du våra <a href='/terms/' className='underline' target='_blank'>användarvillkor</a> och <a href='/privacy/' className='underline' target='_blank'>integritetspolicy</a>. Jag förstår att ett konto skapas.</Text>
            </Checkbox>
            {LoginContext.errors.terms_and_conditions_accepted && <HelperText className='text-danger-500 fill-danger-500 justify-center mt-2' icon='ExclamationFilled' label={LoginContext.errors.terms_and_conditions_accepted} />}
        </> : LoginContext.exists?.email == true ? <>
            <Text variant='subheaderSmallMedium' className='mb-2'>Logga in på ditt konto</Text>

            <Text variant='bodySmallRegular' className='text-pebble-500 mb-8'>Ange och verifiera din e-postadress eller telefonnummer.</Text>

            {LoginContext.getFormFields()}

            <Button tw variant='secondary' onClick={() => showCancelPopup(true)} className='mt-2' fullWidth>Avbryt</Button>

            <Button tw variant='primary' className='flex justify-between mt-3' onClick={() => LoginContext.sendLoginRegister()} disabled={LoginContext.loading} fullWidth><div className='flex items-center gap-2'><Icon tw name='PasswordSimple' className='fill-white-500' /><span>Få verifieringskod</span></div> {LoginContext.loading ? <div class="size-4 border-2 border-charcoal-500 border-t-transparent border-solid rounded-full animate-spin"></div> : <Icon tw name='ArrowRightSimple' className='fill-white-500' />}</Button>
        </> : <>
            <Text variant='subheaderSmallMedium' className='mb-2'>Koppla eller skapa ditt konto</Text>

            <Text variant='bodySmallRegular' className='text-pebble-500 mb-8'>Ange och verifiera din e-postadress.</Text>

            {LoginContext.getFormFields()}

            <Button tw variant='secondary' onClick={() => showCancelPopup(true)} className='mt-2' fullWidth>Avbryt</Button>

            <Button tw variant='primary' onClick={() => LoginContext.sendLoginRegister()} className='mt-2' disabled={LoginContext.loading || (!LoginContext.data.email || !isPhoneValid(LoginContext.data.mobile_phone_number))} fullWidth>Koppla Konto {LoginContext.loading && <div class="size-4 border-2 border-charcoal-500 border-t-transparent border-solid rounded-full animate-spin"></div>}</Button>
        </>}

        <Dialog isOpen={cancelPopup} size='small'>
            <Dialog.Header>
                <div className="flex w-full justify-between">
                    <Text variant="subheaderSmallMedium">Är du säker på att du vill avbryta?</Text>
                    <Button tw variant="outline" size="icon" onClick={() => showCancelPopup(false)}>
                        <Icon tw name="CrossSimple" className="color-charcoal-500" size="medium" />
                    </Button>
                </div>
            </Dialog.Header>
            <Dialog.Content className='my-auto'>
                <Text variant="bodySmallRegular" className='text-pebble-500'>Om du avbryter nu, kommer dina ändringar inte att sparas och du behöver verifera dig på nytt.</Text>
            </Dialog.Content>
            <Dialog.Footer>
                <Button tw variant="primary" className='w-full' onClick={() => LoginContext.close(true)}>Ja, avbryt</Button>
                <Button tw variant="secondary" className='w-full' onClick={() => showCancelPopup(false)}>Nej, fortsätt</Button>
            </Dialog.Footer>
        </Dialog>
    </>
}
